import { createSelector } from "reselect";
import { isObjectNotEmpty } from "../Utils";

export function getAttachment(fileId) {
    return (state) => state?.attachment?.[fileId];
}

export function getToken() {
    return (state) => state?.token;
}

export function getParse() {
    return (state) => state?.parseData;
}

export function getForm() {
    return (state) => state?.form;
}

export function getFormTemp() {
    return (state) => state?.formTemp;
}

export function getApproverEditFormTemp() {
    return (state) => state?.approverEditFormTemp;
}

export function getIsLoading() {
    return (state) => state?.isLoading;
}

export function getLoading() {
    return createSelector(getIsLoading(), (isLoading) =>
        Object.entries(isLoading).some((l) => l[1])
    );
}

export function getLoadingByAction(action) {
    return createSelector(getIsLoading(), (isLoading) => isLoading?.[action]);
}

export function getMode() {
    return createSelector(getForm(), (form) => form?.mode);
}

export function getFormId() {
    return createSelector(getForm(), (form) => form?.formId);
}

export function getCurrentStep() {
    return createSelector(getForm(), (form) => form?.currentStep);
}
export function getInitialStep() {
    return createSelector(getForm(), (form) => form?.initialStep);
}
export function getStatus() {
    return createSelector(getForm(), (form) => form?.status);
}
export function getFieldValues() {
    return createSelector(getForm(), (form) => form?.fieldValues);
}
export function getFieldValuesByStep(stepName) {
    return createSelector(getForm(), (form) => form?.fieldValues?.[stepName]);
}

export function getVersion() {
    return createSelector(getForm(), (form) => form?.version);
}

export function getParams() {
    return createSelector(getForm(), (form) => form?.params);
}

export function getScrn() {
    return createSelector(getForm(), (form) => form?.scrn);
}

export function getMobileNavStatus() {
    return (state) => state?.isMobileNavOpen;
}

export function getMultiSubmitEditing() {
    return (state) => state?.isMultiSubmitEditing;
}

export function getIsExceedingDeadline() {
    return (state) => state?.isExceedingDeadline;
}

export function getIsLoginDialogOpen() {
    return (state) => state?.isLoginDialogOpen;
}

export function getRedirectUrl() {
    return (state) => state?.redirectUrl;
}

export function getProfile() {
    return (state) => state?.profile;
}

export function getUserRole() {
    return createSelector(getProfile(), (profile) => profile?.role);
}

export function getUserEmail() {
    return createSelector(getProfile(), (profile) => profile?.email);
}

export function getUserOrg() {
    return (state) => state?.userOrg;
}

export function getSelectedUserOrg() {
    return (state) => state?.selectedUserOrg;
}

export function getCurrentWorkFlow() {
    return (state) => state?.currentWorkFlow;
}

export function getSearchData() {
    return (state) => state?.searchData;
}

export function getUserSCRN() {
    return createSelector(
        getSelectedUserOrg(),
        (selectedUserOrg) => selectedUserOrg?.scrn
    );
}

export function getPopupStatus(type) {
    return (state) => state?.isPopupOpen?.[type];
}

export function getIamsmart() {
    return (state) => state?.iamsmart;
}

export function getIamsmartProfile() {
    return createSelector(getIamsmart(), (iamsmart) => iamsmart?.profile);
}

export function getIamsmartOpenID() {
    return createSelector(getIamsmartProfile(), (profile) => profile?.openID);
}

export function getIamsmartContent() {
    return createSelector(getIamsmart(), (iamsmart) => iamsmart?.content);
}

export function getIamsmartFieldMap() {
    return createSelector(getIamsmart(), (iamsmart) => iamsmart?.fieldMap);
}

export function getIasTokenMap() {
    return createSelector(getIamsmart(), (iamsmart) => iamsmart?.iasTokenMap);
}

export function getIamsmartAccessToken() {
    return createSelector(
        getIamsmartProfile(),
        (iamsmart) => iamsmart?.accessToken
    );
}

export function getFormSubmittingData() {
    return createSelector(getFieldValues(), (formSteps) => {
        if (isObjectNotEmpty(formSteps)) {
            return Object.getOwnPropertyNames(formSteps).reduce(
                (data, stepName) => ({
                    ...data,
                    ...formSteps?.[stepName],
                }),
                {}
            );
        } else {
            return {};
        }
    });
}

export function getCLO() {
    return (state) => state?.clo;
}

export function getFailRes() {
    return (state) => state?.failRes;
}

export function getApplicantFormList() {
    return (state) => {
        return state?.applicantFormList;
    };
}

export function getStepSequence() {
    return createSelector(getForm(), (form) => form?.stepSequence);
}

export function getFormTitleParamList() {
    return (state) => {
        return state?.formTitleParamList;
    };
}

export function getKindergartenCccName() {
    return (state) => {
        return state?.kindergartenCccName;
    };
}

export function getSchoolList() {
    return (state) => {
        return state?.schoolList;
    };
}

export function getForm101EffectiveJob() {
    return (state) => {
        return state?.form101EffectiveJob;
    };
}
export function getLatestParameter() {
    return (state) => {
        return state?.latestParameter;
    };
}

export function getServerTime() {
    return (state) => {
        return state?.serverTime;
    };
}

export function getAllCollBoxGroupAuth() {
    return (state) => {
        return state?.allCollBoxGroupAuth;
    };
}

// export function getFormStepsSelector(formId) {
//     return createSelector(getFormSelector(formId), (form) => form?.steps);
// }

// export function getFormSpecificStepSelector(formId, step) {
//     return createSelector(getFormStepsSelector(formId), (formSteps) => {
//         formSteps?.[`step${step}`];
//     });
// }

// export function getFormSubmittingDataSelector(formId) {
//     return createSelector(getFormStepsSelector(formId), (formSteps) => {
//         if (isObjectNotEmpty(formSteps)) {
//             return Object.getOwnPropertyNames(formSteps).reduce(
//                 (data, stepName) => ({
//                     ...data,
//                     ...formSteps?.[stepName]?.fieldValues,
//                 }),
//                 {}
//             );
//         } else {
//             return {};
//         }
//     });
// }
